import styled from 'styled-components'
import { adjust, themeBreakPoints, smallLayout } from '@chegg-wt/core/theme/theme'

export const Container = styled.section`
  background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor20};
`
export const Wrapper = styled.div`
  margin-left: auto;
  margin-right: auto;
  padding: 8px;
  max-width: 900px;
  @media (min-width: ${(props) => adjust(themeBreakPoints.extraSmall(props.theme), 20)}) {
    padding: 16px 32px;
  }
  @media (max-width: ${(props) => smallLayout(props.theme)}) {
    padding: 16px 16px;
  }
`
